import React from 'react';
import { ClockIcon, ShieldCheckIcon, StarIcon } from '@heroicons/react/24/outline';
import Card from '../../../components/common/Card';

interface Feature {
  icon: React.ReactNode;
  title: string;
  description: string;
  color: string;
}

const FeaturesSection: React.FC = () => {
  const features: Feature[] = [
    {
      icon: <ClockIcon className="w-8 h-8" />,
      title: 'Instant Booking',
      description: 'Book appointments in seconds with real-time availability',
      color: 'from-primary-500 to-cyan-500',
    },
    {
      icon: <ShieldCheckIcon className="w-8 h-8" />,
      title: 'Verified Professionals',
      description: 'All providers are verified and highly rated by customers',
      color: 'from-accent-500 to-pink-500',
    },
    {
      icon: <StarIcon className="w-8 h-8" />,
      title: 'Top Rated Services',
      description: 'Access to premium services across multiple industries',
      color: 'from-orange-500 to-red-500',
    },
  ];

  return (
    <section className="py-10 sm:py-16 px-3 xs:px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl xs:text-3xl sm:text-4xl font-bold text-gray-900 mb-2 sm:mb-4">
            Why Choose Appointigo?
          </h2>
          <p className="text-sm sm:text-lg text-gray-600 max-w-2xl mx-auto px-2">
            The smartest way to book appointments with trusted professionals
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
          {features.map((feature) => (
            <Card
              key={feature.title}
              className="border border-gray-100"
              hover
            >
              <div className={`w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br ${feature.color} rounded-lg sm:rounded-xl flex items-center justify-center text-white mb-3 sm:mb-4`}>
                {React.cloneElement(feature.icon as React.ReactElement, { className: 'w-6 h-6 sm:w-8 sm:h-8' })}
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-1 sm:mb-2">
                {feature.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600">
                {feature.description}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
